// "Mejorar instrucción" / "Generar ideas" — webhook n8n `generar-instrucciones`
// migrado a atlas `/v1/prompting/instrucciones` (ADR-597). El backend soporta
// los TRES tipo_de_prompt del front (creativo, escena, video) con contratos de
// respuesta idénticos: `{prompt_mejorado}` o `{posts:[{titulo,prompt}]}` (el
// formato viejo `{ideas: string[]}` solo puede venir del fallback n8n).
// Flag ADENTRO del helper, patrón de siempre:
//   ON  → atlas con JWT (`user_id` del body NO viaja, sale del token)
//   OFF → webhook n8n byte-idéntico (token estático + user_id en el body).
// Sin créditos: no cobra. Errores del atlas: 400 modo inválido (n8n colgaba),
// 500 {error} — se tiran como Error con el mensaje del backend si existe.

import { GENERATE_AUTH_TOKEN, USE_ATLAS_BACKEND } from '../config';
import { atlasBackendFetch } from './atlasBackend';

const GENERAR_INSTRUCCIONES_URL =
  'https://ai-agency-dt7d.onrender.com/webhook/generar-instrucciones';

export interface PromptInstruccionesBody {
  user_id: string;
  modo: 'mejorar' | 'generar_ideas';
  tipo_de_prompt: 'creativo' | 'escena' | 'video';
  /** Requerido con modo 'mejorar'. */
  prompt?: string;
  variante_id?: string | string[];
}

export interface PromptInstruccionesResponse {
  prompt_mejorado?: string;
  posts?: Array<{ titulo?: string; prompt?: string }>;
  /** Formato viejo (solo n8n). */
  ideas?: string[];
}

export async function postPromptInstrucciones(
  body: PromptInstruccionesBody,
): Promise<PromptInstruccionesResponse> {
  if (USE_ATLAS_BACKEND) {
    const { user_id: _ignored, ...atlasBody } = body;
    const res = await atlasBackendFetch('/v1/prompting/instrucciones', atlasBody);
    if (!res.ok) {
      let msg = '';
      try {
        msg = ((await res.json()) as { error?: string })?.error || '';
      } catch { /* body no-JSON */ }
      throw new Error(msg || `Error ${res.status} generando instrucciones`);
    }
    return (await res.json()) as PromptInstruccionesResponse;
  }
  const res = await fetch(GENERAR_INSTRUCCIONES_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: GENERATE_AUTH_TOKEN,
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`Error ${res.status} generando instrucciones`);
  return (await res.json()) as PromptInstruccionesResponse;
}
